import { Routes, Route } from "react-router";
import Layout from "./components/Layout.jsx";
import Home from "./pages/Home.jsx";
import ShowPage from "./pages/ShowPage.jsx";
import MediatorPage from "./pages/MediatorPage.jsx";
import NotFound from "./pages/NotFound.jsx";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="show/:slug" element={<ShowPage />} />
        <Route path="watch/:slug/:id" element={<MediatorPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

